import React, { useContext, useEffect, useState } from 'react'
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import { getCompsReport } from '../../../../Components/PropertySearch/Services/propertySearchService'
import { Popover } from '@material-ui/core'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import listContext from '../../../Common/context/context'
import searchContext from '../../../PropertySearch/FiltersComponent/context/context'
import XLSX from "xlsx"
import {
  getPropertyTypeColor, getFormattedNumber, getRentViewSettings,
  getSummaryColumnsList, getTotalAvgForSummaryComps, isUndefinedOrNull, sortArray,
  valueFormatter, getUnitMixSource, isHealthCareProperty, isStudentHousingProperty,
  totalDataCountExt, divideNumbers, getAnnualEffectiveRent, sortUnitMixData
} from '../../Utility/PropertyListUtility';
import { displayDateFormat } from '../../../PropertySearch/Utility/Utility'
import exportNonFormatSummaryColumns from './ExportNonFormatSummaryColumns.js';
import { exportNonFormatPropertyInfoColumns, salesPropertyInfoCols } from './ExportNonFormatPropertyInfoColumns';
import exportNonFormatUnitMixColumns from './ExportNonFormatUnitMixColumns'
import exportNonFormatMapDataColumns from './ExportNonFormatMapDataColumns'
// import MapComponent from '../../../PropertySearch/MapComponent/MapComponent'
// import html2canvas from 'html2canvas';
// import subjectIcon from '../../../PropertySearch/Assets/star.png'

function converBase64toBlob(content, contentType) {
  contentType = contentType || '';
  var sliceSize = 512;
  var byteCharacters = window.atob(
    content);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset +=
    sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
}

const ExportListButton = () => {

  let { propertyList } = useContext(listContext)
  let { setShowAlert, setalertProps } = useContext(searchContext)

  const [exportClicked, setExportClicked] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [template, setTemplate] = useState("default")
  const [photo, isPhoto] = useState(true)
  const [showMap, setShowMap] = useState(false)
  const [showOwner, setShowOwner] = useState(false)
  const [showManager, setShowManager] = useState(false)
  const [buyerSeller, setBuyerSeller] = useState(true)
  const [caprate, setCaprate] = useState(true)
  const [GRM, setGRM] = useState(true)
  const [unitMix, setUnitMix] = useState(true)
  const [webURL, setWebURL] = useState()

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (exportClicked) {
      handleGetCompsReport()
    }
  }, [exportClicked])

  useEffect(() => {

    let webAdd = 'https://maps.googleapis.com/maps/api/staticmap?size=720x320&maptype=roadmap'

    if (propertyList && propertyList.compsList) {
      let index = 1
      propertyList.compsList.forEach(item => {
        try {
          let omniviewproperty = item.data.omniviewproperty[0]
          omniviewproperty.isSubjectProperty = item.isSubjectProperty
          // debugger
          // let color = item.isSubjectProperty ? 'yellow' : '0x212f47'
          let iconColor = getPropertyTypeColor(item.data.omniviewproperty[0].omniViewPropertyType)
          iconColor = iconColor.replace('#', '0x')

          let color = item.isSubjectProperty ? 'yellow' : iconColor

          let label = omniviewproperty.isSubjectProperty ? 'S' : index
          // let icon = item.isSubjectProperty ? `icon:${subjectIcon}|` : ''
          webAdd = `${webAdd}&markers=color:${color}|label:${label}|${item.data.propertyLocation}`

          index = item.isSubjectProperty ? index : index + 1
        } catch (error) {
          console.log(`error in webAdd ${error}`)
        }
      })

      webAdd = `${webAdd}&key=${window.REACT_GLOBAL_CONFIG.REACT_APP_GOOGLE_API_KEY}`

      setWebURL(webAdd)
      // console.log('webAdd = ', webAdd)

    }

  }, [propertyList])

  const handleGetCompsReport = async () => {
    if (template === 'text') {
      createNonFormattedExcel()
      return
    }

    // console.log(webURL.toDataURL())

    let imgBlob = await fetch(webURL).then(r => r.blob());
    let dataURL = await new Promise(resolve => {
      let reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(imgBlob);
    });
    // console.log('dataURL = ', dataURL)
    dataURL = dataURL.replace('data:image/png;base64,', '')
    const res = await getCompsReport(createRequest(showMap ? dataURL : ''))

    let fileData = JSON.parse(res.data.fileData)

    if (fileData.isError) {
      setalertProps({ message: `Unable to download report. ${fileData.Message}`, type: 'error' })
      setShowAlert(true)
      setExportClicked(false)
      return;
    }

    let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    let blob = converBase64toBlob(fileData, contentType);
    // const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    const fileName = template === "default" ? `${propertyList.name}.xlsx` : `${propertyList.name} - ${template}.xlsx`
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    setExportClicked(false)
    handleClose()

    // console.log(dataUrl)

    // html2canvas(document.getElementById('output'), {
    //   useCORS: true
    // }).then(
    //   async function (canvas) {
    //     var dataURL = canvas.toDataURL();
    //     dataURL = dataURL.replace('data:image/png;base64,', '')
    //     // console.log(dataURL)
    //     const res = await getCompsReport(createRequest(showMap ? dataURL : ''))
    //     let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    //     let blob = converBase64toBlob(JSON.parse(res.data.fileData), contentType);
    //     // const url = window.URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = window.URL.createObjectURL(blob);
    //     const fileName = template === "default" ? `${propertyList.name}.xlsx` : `${propertyList.name} - ${template}.xlsx`
    //     link.setAttribute('download', fileName);
    //     document.body.appendChild(link);
    //     link.click();
    //     link.remove();
    //     setExportClicked(false)
    //     handleClose()
    //   })

    // let timeOut = showMap ? 0 : 10
    // setTimeout(() => {

    // }, timeOut);

    // const res = await getCompsReport(createRequest())
    // let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8';
    // let blob = converBase64toBlob(JSON.parse(res.data.fileData), contentType);
    // // const url = window.URL.createObjectURL(blob);
    // const link = document.createElement('a');
    // link.href = window.URL.createObjectURL(blob);
    // const fileName = template === "default" ? `${propertyList.name}.xlsx` : `${propertyList.name} - ${template}.xlsx`
    // link.setAttribute('download', fileName);
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
    // setExportClicked(false)
    // handleClose()
  }
  const findIfSubjectPropertyIsSH = () => {
    return propertyList.compsList.filter(property => property.isSubjectProperty && property.data.omniviewproperty[0].omniViewPropertyType === "Student Housing").length
  }
  const getunitMixColumns = (property, isSubjectProperty) => {
    let forColumns = []
    let columns = []

    forColumns = getRentViewSettings(propertyList)
    if (forColumns.length === 0) {
      forColumns.push('market rent')
    }

    if (isHealthCareProperty(property)) {
      forColumns = ['health care']
    }

    if (isStudentHousingProperty(property) && isSubjectProperty) {
      forColumns.push('student housing')
      let tempforColumns = getRentViewSettings(propertyList)

      tempforColumns.forEach(item => {
        let newItem = item === 'high low' ? 'market rent' : item
        forColumns.push(`student housing ${newItem}`)
      })
    }

    columns = exportNonFormatUnitMixColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
    return columns
  }
  const createNonFormattedExcel = () => {
    // console.log('propertyList = ', propertyList)
    let wb = XLSX.utils.book_new()
    wb.Props = {
      Title: propertyList.name,
      // Subject: "Test",
      Author: "Berkadia360",
      CreatedDate: new Date()
    };

    wb.SheetNames.push("Summary");
    createCompsSummarySheet(wb)
    // if (propertyList.compType.toLowerCase() === 'sales') {
    //   // wb = createSalesSummarySheet(wb)
    //   wb = createRentSummarySheet(wb)
    // } else {
    //   wb = createRentSummarySheet(wb)
    // }

    // create property sheet data
    const PROPERTY_COLUMNS = getSummaryColumnsList(propertyList, exportNonFormatPropertyInfoColumns);
    let dataObj = [...propertyList.compsList].map((row, index) => {

      let propObj = {}
      let commentsObj = {}
      let compsSpecific = {}
      // let salesPropertyInfoCols = {
      //   "Built": [ "Built", "Price", "Sale Date"],
      //   "Renovated": [ "Renovated", "Price/Unit", "CAP"],
      //   "Type": [ "Type", "Price/SF", "GRM"],
      //   "Subtype": [ "Subtype", "Avg. Rent/Unit", "Seller"],
      //   "Metering": [ "Metering", "Avg. Rent/SF", "Buyer"]
      // }
      PROPERTY_COLUMNS.forEach(col => {
        if (["Price", "Sale Date", "Price/Unit", "CAP", "Price/SF", "GRM", "Avg. Rent/Unit", "Seller", "Avg. Rent/SF", "Buyer"].includes(col.label)) {
          return
        }

        if ((col.label === 'Owner' && !(showOwner)) || (col.label === 'Manager' && !(showManager))) {
          return
        }

        if (["Rent Comments", "Amenities", "Amenities (write ins)", "Source Notes"].includes(col.label)) {
          if (col.label === "Rent Comments") {
            let div = document.createElement("div");
            div.innerHTML = getFieldValue(col, row);
            commentsObj[col.label] = div.innerText
          } else {
            commentsObj[col.label] = getFieldValue(col, row)
          }
        }
        else if (propertyList.compType.toLowerCase() === "sales" && ["Built", "Renovated", "Type", "Subtype", "Metering"].includes(col.label)) {
          let temp = []
          salesPropertyInfoCols[col.label].forEach(key => {
            temp.push(key)
            temp.push(getFieldValue(PROPERTY_COLUMNS.filter(c => c.label === key)[0], row))
            temp.push("")
          })
          propObj[col.label] = temp
        }
        else {
          if (["Distance", "Distance to Campus"].includes(col.label)) {
            let distance = getFieldValue(col, row);
            propObj[col.label] = `${distance} miles`
            propObj["_EMPTY"] = null
          } else if (["Address"].includes(col.label)) {
            let address = getFieldValue(col, row);
            address = address.replace(',,', ',')
            // propObj[col.label] = `${address},`
            propObj[col.label] = address
          } else {
            propObj[col.label] = getFieldValue(col, row)
          }
        }
      })

      if (unitMix) {
        let sh_flag = findIfSubjectPropertyIsSH() && propertyList && propertyList.compType.toLowerCase() === "rent"
        // unit mix tables
        let forColumns = getRentViewSettings(propertyList)
        let unitmixColumns = getunitMixColumns(row.data.omniviewproperty[0], sh_flag) // exportNonFormatUnitMixColumns.filter(col => col.for.some(r => forColumns.indexOf(r) >= 0))
        let unitMixData = updateDataBySource(propertyList.compsList[index].data, row)
        unitMixData = calculateColumnValues(unitMixData, row.data.omniviewproperty[0])
        // sort the data
        if (propertyList.compsList[index].sortBy) {
          unitMixData = sortUnitMixData(unitMixData, propertyList.compsList[index].sortBy, propertyList.compsList[index].sortOrder)
        } else {
          unitMixData = unitMixData.sort((a, b) => a.unitType.localeCompare(b.unitType) || a.units - b.units)
        }

        let unitMixObj = {}
        let umix = unitMixData.map((row) => (
          unitmixColumns.map((col) => {
            // unitMixObj[col.label] = getUMFieldValue(row, col)
            let val;
            if (col.label === "MR/BED" || col.label === "ER/BED") {
              val = getUMFieldValue(row, col)
              val = val === "$0" ? "" : val
            } else {
              val = getUMFieldValue(row, col)
            }
            return val
          })
        ))
        /////// unit mix total row
        let totalUnitMix = unitmixColumns.map((col) => (
          unitMixObj[col.label] = getUMSummaryValue(row.data.omniviewproperty[0], col)
        ))
        //////
        umix.push(totalUnitMix)
        let unitMixHeaders = unitmixColumns.map(header => header.label)
        let unitMixSubHeaders = unitmixColumns.map(header => header.sumLabel)
        if (umix.length > 1) {
          umix.unshift(unitMixSubHeaders)
          umix.unshift(unitMixHeaders)
          umix.unshift(["Unit MIX"])
        } else {
          umix.unshift([])
          umix.unshift([])
          umix.unshift(["Unit MIX", " - No Records"])
        }


        umix.unshift([])
        umix.push([])
        propObj.unitMix = umix;
        //
      }
      return { ...propObj, ...commentsObj };
    })

    dataObj.forEach(property => {
      wb = createPropertySheet(wb, property)
    });

    // if(map){
    wb = createMapDataSheet(wb)
    // }

    var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    var options = { year: 'numeric', month: '2-digit', day: '2-digit' }
    let date = new Intl.DateTimeFormat('en-US', options).format(new Date())
    let currentDate = date.replace("//g", "_")
    let compsType = propertyList && propertyList.compType.toLowerCase()
    saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), `${propertyList.name}_${compsType}_view_${currentDate}.xlsx`)

    setExportClicked(false)
    handleClose()
  }

  const valueFormatterUnitMix = (inputVal, type = 'text') => {

    let returnVal = inputVal ? inputVal : ''

    try {
      returnVal = returnVal.toString()

      switch (type) {
        case 'number':
          returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '', '2', '2') : getFormattedNumber(returnVal)
          break
        case 'percent':
          returnVal = getFormattedNumber(returnVal, '%')
          break
        case 'currency':
          returnVal = returnVal.includes('.') ? getFormattedNumber(returnVal, '$', '2', '2') : getFormattedNumber(returnVal, '$')
          break
        default: break
      }

      returnVal = !returnVal ? '-' : returnVal

    } catch (error) {
      console.log("error in valueFormatter ::: " + error.message)
    }

    return returnVal

  }
  const calculateColumnValues = (unitMixData, property) => {
    if (unitMixData.length < 1) {
      return []
    }

    let totalUnits = totalDataCountExt('units', unitMixData, unitMixData[0].source, false)

    let newUnitMixData = [...unitMixData]

    for (let i = 0; i < newUnitMixData.length; i++) {
      try {
        newUnitMixData[i].unitPercentage = divideNumbers(newUnitMixData[i].units, totalUnits) * 100
        newUnitMixData[i].highLow = valueFormatterUnitMix(newUnitMixData[i].minRent, 'currency') + ' - ' + valueFormatterUnitMix(newUnitMixData[i].maxRent, 'currency')
        // if (newUnitMixData[i].ER_Bed) {
        //     newUnitMixData[i].ER_Bed = Math.round(newUnitMixData[i].ER_Bed)
        // }

        newUnitMixData[i].annualEffectiveRent = getAnnualEffectiveRent(newUnitMixData[i])

        if (isStudentHousingProperty(property) || isHealthCareProperty(property)) {
          newUnitMixData[i].bedsPerUnit = divideNumbers(newUnitMixData[i].beds, newUnitMixData[i].units)
          newUnitMixData[i].erBed = divideNumbers(newUnitMixData[i].totalEffectiveRent, newUnitMixData[i].beds)
          newUnitMixData[i].erBed = newUnitMixData[i].erBed.toFixed(0)
        }

      } catch (error) {
        console.log("error in calculateColumnValues ::: " + error.message)
      }

    }

    return newUnitMixData

  }

  const updateDataBySource = (data, row) => {
    let ovPropertyrent = []
    if (data && data.omniviewpropertyrent) {
      let newSource = ''
      newSource = getUnitMixSource({ 'compsList': [row] }, row.omniViewPropertyId)
      ovPropertyrent = data.omniviewpropertyrent.filter(x => x.source && x.source.toLowerCase() === newSource.toLowerCase())
    }
    return ovPropertyrent
  }

  const getCompType = () => {

    let returnVal = 'rent'
    if (propertyList && propertyList.compType) {
      returnVal = propertyList.compType.toLowerCase()
    }

    return returnVal
  }

  const getUMSummaryValue = (fieldRow, fieldCol) => {

    let returnVal = ''

    try {

      returnVal = isUndefinedOrNull(fieldRow[fieldCol.sumfieldName])
      returnVal = valueFormatterUnitMix(returnVal, fieldCol.type)

    } catch (error) {
      console.log("error in getUMSummaryValue ::: " + error.message)
    }

    if (returnVal === "-") {
      returnVal = ""
    }
    return returnVal

  }
  const getUMFieldValue = (fieldRow, fieldCol) => {

    let returnVal = ''

    try {
      returnVal = isUndefinedOrNull(fieldRow[fieldCol.fieldName])
      if (returnVal && (fieldCol.fieldName === "rentPerSf" || fieldCol.fieldName === "effectiveRentPerSft")) {
        returnVal = parseFloat(returnVal).toFixed(2);
      }
      returnVal = valueFormatterUnitMix(returnVal, fieldCol.type)

      if (fieldCol.type === 'date' && returnVal && returnVal !== '-' && returnVal.length !== 4) {
        returnVal = displayDateFormat(returnVal)
      }
      // if (fieldCol.type === 'date') {
      //   var options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      //   returnVal = new Intl.DateTimeFormat('en-US', options).format(new Date(returnVal))
      // }
    } catch (error) {
      console.log("error in getFieldValue ::: " + error.message)
    }

    if (returnVal === "-") {
      returnVal = ""
    }
    return returnVal

  }

  const getFieldValueTotal = (fieldCol) => {
    const totalAvgs = getTotalAvgForSummaryComps(propertyList)
    let returnVal = ''
    // let compType = getCompType().charAt(0).toUpperCase() + s.slice(1)

    try {

      returnVal = totalAvgs[getCompType()][fieldCol.summaryFieldName]
      if (fieldCol.fieldName === 'transactionHistoryCapRate') {
        returnVal = returnVal.toFixed(2)
      }
      returnVal = valueFormatter(returnVal, fieldCol.type)
      if (returnVal === "-") {
        returnVal = ""
      }

    } catch (error) {
      console.log("error in getFieldValue ::: " + error.message)
    }

    return returnVal

  }

  const getFieldValue = (rowParam, row) => {
    const { data, omniViewPropertyId, excludeProperty } = row
    const omniviewproperty = data.omniviewproperty[0]
    const omniviewpropertyrent = data.omniviewpropertyrent
    let lstOmniviewtransactionhistory = [...data.omniviewtransactionhistory]
    lstOmniviewtransactionhistory = lstOmniviewtransactionhistory.filter(x => x.transactionType && x.transactionType.toLowerCase() === 'sale')
    lstOmniviewtransactionhistory = [...sortArray(lstOmniviewtransactionhistory, 'saleDate', 'desc')]
    const omniviewtransactionhistory = lstOmniviewtransactionhistory.length ? lstOmniviewtransactionhistory[0] : {}

    let returnVal = ''
    try {
      let field_name = rowParam.fieldName
      if (rowParam.label === "Seller") {
        field_name = omniviewtransactionhistory['sfSellerAccountId'] ? 'sfSellerAccountName' : rowParam.fieldName
      }
      if (rowParam.label === "Buyer") {
        field_name = omniviewtransactionhistory['sfBuyerAccountId'] ? 'sfBuyerAccountName' : rowParam.fieldName
      }

      if (rowParam.dataObj === 'omniviewtransactionhistory' && omniviewtransactionhistory[field_name]) {
        returnVal = omniviewtransactionhistory[field_name]
        if (rowParam.label === "Price/Unit" || rowParam.label === "Sale Price" || rowParam.label === "Price") {
          // returnVal = parseFloat(returnVal) ? (parseFloat(returnVal)).toFixed(0) : returnVal
          returnVal = parseInt(returnVal) ? parseInt(returnVal) : returnVal
        }
        if (rowParam.label === "CAP") {
          returnVal = parseFloat(returnVal) ? (parseFloat(returnVal)).toFixed(2) : returnVal
        }
      }
      if (rowParam.dataObj === 'omniviewproperty' && omniviewproperty[rowParam.fieldName]) {
        if (rowParam.fieldName === 'propertyName') {
          let propertyName_30 = omniviewproperty[rowParam.fieldName].substring(0, 30)
          propertyName_30 = propertyName_30.replace(/[:\/?]/g, '');
          returnVal = propertyName_30
        } else {
          returnVal = omniviewproperty[rowParam.fieldName]
        }
      }
      if (rowParam.fieldName === "amenities" && rowParam.dataObj === 'omniviewpropertyrent' && omniviewpropertyrent.length > 0 && omniviewpropertyrent[0][rowParam.fieldName]) {
        returnVal = omniviewpropertyrent[0][rowParam.fieldName]
      }
      // if (rowParam.dataObj === 'omniviewproperty' && rowParam.fieldName === 'yearBuilt' && (omniviewproperty['yearBuilt'] || omniviewproperty['yearRenovated'])) {
      //     let built = omniviewproperty[rowParam.fieldName] ? omniviewproperty[rowParam.fieldName] : '-'
      //     let reno = omniviewproperty['yearRenovated'] ? omniviewproperty['yearRenovated'] : '-'
      //     if (propertyList.showReno) {
      //         returnVal = `${built} | ${reno}`
      //     } else {
      //         returnVal = built
      //     }

      // }

      if (rowParam.fieldName !== 'yearBuilt' && rowParam.type === 'date' && returnVal && returnVal !== '-' && returnVal.length !== 4) {
        returnVal = displayDateFormat(returnVal)
      }
      // if (rowParam.fieldName !== 'yearBuilt' && rowParam.type === 'date' && returnVal && returnVal !== '-' && returnVal.length !== 4) {
      //   var options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      //   returnVal = new Intl.DateTimeFormat('en-US', options).format(new Date(returnVal))
      //   // returnVal = new Intl.DateTimeFormat('en-US').format(new Date(returnVal))
      // }

      if (rowParam.fieldName === 'distanceFromSubject' && row.isSubjectProperty) {
        returnVal = 0
      }
      returnVal = returnVal.toString()

      if (returnVal && returnVal !== '-') {

        switch (rowParam.type) {
          case 'number':
            returnVal = getFormattedNumber(returnVal)
            break
          case 'percent':
            // returnVal = getFormattedNumber(returnVal, '%')
            if (returnVal.includes('.')) {
              returnVal = getFormattedNumber(returnVal, '%', '2', '2')
            } else {
              returnVal = getFormattedNumber(returnVal, '%')
            }
            break
          case 'currency':
            if (returnVal.includes('.')) {
              returnVal = getFormattedNumber(returnVal, '$', '2', '2')
            } else {
              returnVal = getFormattedNumber(returnVal, '$')
            }
            break
          default: break
        }
      }
    } catch (error) {
      console.log('error in getFieldValue in Propertylisttable::', error)
    }

    if (rowParam.fieldName === 'propertyAddressLatitude' || rowParam.fieldName === 'propertyAddressLongitude') {
      returnVal = Number(returnVal)
    }

    return returnVal
  }

  const getSubjectPropertyCount = () => {
    let count = 0;
    propertyList.compsList.forEach(t => {
      if (t.isSubjectProperty) {
        count++
      }
    })
    return count
  }

  const createCompsSummarySheet = wb => {
    const SUMMARY_COLUMNS = getSummaryColumnsList(propertyList, exportNonFormatSummaryColumns);
    let subjectPropertyCount = getSubjectPropertyCount();
    let sCount = 1
    let compsCount = 1
    let dataObj = [...propertyList.compsList].map((row, index) => {

      let summaryObj = {}

      SUMMARY_COLUMNS.forEach(col => {
        if (col.label === "isSubjectProperty") {
          summaryObj[''] = row.isSubjectProperty ? (subjectPropertyCount > 1 ? `S${sCount++}` : 'S') : compsCount++
        } else if (col.label === "# Beds") {
          let beds = getFieldValue(col, row)
          summaryObj[col.label] = beds === "0" ? "" : beds
        } else if (col.label === "MR/Bed" || col.label === "ER/Bed") {
          let perBed = getFieldValue(col, row)
          summaryObj[col.label] = perBed === "$0" ? "" : perBed
        } else {
          summaryObj[col.label] = getFieldValue(col, row)
        }
      })
      return summaryObj;
    })
    let totalObj = {}
    let tObj = SUMMARY_COLUMNS.map(col => {
      return totalObj[col.label] = getFieldValueTotal(col)
    })

    try {
      var ws_data = []  //a row with 2 columns
      let column_headers = SUMMARY_COLUMNS.map(s => s.label === "isSubjectProperty" ? "" : s.label)
      ws_data.push(column_headers)
      // ws_data.push(['', 'Property Name', 'City', 'Distance', 'Units', 'Built', 'Renovated', 'Occupancy', 'RSF', 'Avg SF', 'Avg Market  Rent', 'Avg Rent/SF', 'Updated', 'Notes'])
      dataObj.forEach(obj => {
        ws_data.push(Object.values(obj))
      })
      ws_data.push(tObj)
      var ws = XLSX.utils.aoa_to_sheet(ws_data)
      wb.Sheets["Summary"] = ws
    } catch (error) {
      console.log('error in ', createCompsSummarySheet)
    }

    return wb
  }

  const createPropertySheet = (wb, property) => {
    try {
      let propertyName_30 = property["Property Name"].substring(0, 30)
      propertyName_30 = propertyName_30.replace(/[:\/?]/g, '');
      wb.SheetNames.push(propertyName_30)
      var ws_data = []
      Object.entries(property).forEach(i => {
        if (i[0] === "unitMix") {
          i[1].forEach(u => ws_data.push(u))
        } else if (propertyList.compType.toLowerCase() === "sales" && ["Built", "Renovated", "Type", "Subtype", "Metering"].includes(i[0])) {
          ws_data.push(i[1])
        } else {
          if (i[0] === "_EMPTY") {
            ws_data.push([])
          } else {
            ws_data.push(i)
          }
        }
      })
      // ws_data.push(['Property Name', property["Property Name"]])
      var ws = XLSX.utils.aoa_to_sheet(ws_data)
      wb.Sheets[property["Property Name"]] = ws
    } catch (error) {
      console.log('error in ', createPropertySheet)
    }

    return wb
  }

  const createMapDataSheet = wb => {
    const SUMMARY_COLUMNS = getSummaryColumnsList(propertyList, exportNonFormatMapDataColumns);
    let subjectPropertyCount = getSubjectPropertyCount();
    let sCount = 1
    let compsCount = 1
    let dataObj = [...propertyList.compsList].map((row, index) => {

      let summaryObj = {}
      SUMMARY_COLUMNS.forEach(col => {
        if (col.label === "isSubjectProperty") {
          summaryObj[''] = row.isSubjectProperty ? (subjectPropertyCount > 1 ? `S${sCount++}` : 'S') : compsCount++
        } else {
          summaryObj[col.label] = getFieldValue(col, row)
        }
      })
      return summaryObj;
    })
    let totalObj = {}
    let tObj = SUMMARY_COLUMNS.map(col => {
      return totalObj[col.label] = getFieldValueTotal(col)
    })
    try {
      wb.SheetNames.push('Map Data')
      var ws_data = []  //a row with 2 columns
      let column_headers = SUMMARY_COLUMNS.map(s => s.label === "isSubjectProperty" ? "" : s.label)
      ws_data.push(column_headers)
      // ws_data.push(['', 'Property Name', 'City', 'Distance', 'Units', 'Built', 'Renovated', 'Occupancy', 'RSF', 'Avg SF', 'Avg Market  Rent', 'Avg Rent/SF', 'Updated', 'Notes'])
      dataObj.forEach(obj => {
        ws_data.push(Object.values(obj))
      })
      ws_data.push(tObj)
      var ws = XLSX.utils.aoa_to_sheet(ws_data)
      wb.Sheets['Map Data'] = ws
    } catch (error) {
      console.log('error in ', createPropertySheet)
    }

    return wb
  }

  function s2ab(s) {
    var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
  }

  const createRequest = mapScreenShot => {
    let propSource = []

    propertyList && propertyList.compsList.map(comps => {
      propSource.push({
        "PropertyID": comps.data.omniviewproperty[0].omniViewPropertyId,
        "Source": comps.data.omniviewproperty[0].source ? comps.data.omniviewproperty[0].source : '',
        "sortBy": comps.sortBy ? comps.sortBy : '',
        "sortOrder": comps.sortOrder ? comps.sortOrder : '',
      })
    })

    // let reportType = propertyList && propertyList.compType.toLowerCase() ? propertyList.compType.toLowerCase() : 'rent'

    return {
      "PolarisPropertySearchCriteriaId": propertyList && propertyList.polarisPropertySearchCriteriaId,
      "CompListID": propertyList && propertyList.omniViewPropertyListId,
      "ReportType": propertyList && propertyList.compType.toLowerCase(),
      // "ReportType": reportType,
      "Template": template,
      "ShowBuyerSeller": buyerSeller,
      "ShowCAPRate": caprate,
      "ShowGRM": GRM,
      "ShowPhoto": photo,
      "ShowUnitMix": unitMix,
      "ShowOwner": showOwner,
      "ShowManager": showManager,
      // "ShowMap": map,
      "PropSource": propSource,
      "from": "polaris",
      "mapScreenShot": mapScreenShot
    }

    // console.log('mapScreenshot = ', mapScreenshot)


    // return {
    //   "PolarisPropertySearchCriteriaId": propertyList && propertyList.polarisPropertySearchCriteriaId,
    //   "CompListID": propertyList && propertyList.omniViewPropertyListId,
    //   "ReportType": propertyList && propertyList.compType.toLowerCase(),
    //   "Template": template,
    //   "ShowBuyerSeller": buyerSeller,
    //   "ShowCAPRate": caprate,
    //   "ShowGRM": GRM,
    //   "ShowPhoto": photo,
    //   "ShowUnitMix": unitMix,
    //   // "ShowMap": map,
    //   "PropSource": propSource,
    //   "from": "polaris"
    // }
  }

  const open = Boolean(anchorEl)

  const getMapsPropertyList = () => {
    let mapsPropertyList = []

    if (propertyList && propertyList.compsList) {
      propertyList.compsList.forEach(item => {
        let omniviewproperty = item.data.omniviewproperty[0]
        omniviewproperty.isSubjectProperty = item.isSubjectProperty
        omniviewproperty.propertyLocation = item.data.propertyLocation
        mapsPropertyList.push(omniviewproperty)
      })
    }

    return mapsPropertyList
  }

  return (
    <>
      <button onClick={handleClick} data-testid="test-export-report" title="Export list" className="p-2 btn rounded-full" >
        <SaveAltIcon fontSize="small" />
      </button>
      <Popover open={open} anchorEl={anchorEl} onClose={handleClose} className="overflow-y-hidden"
        PaperProps={{
          style: { width: '472px', height: '350px' },
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }} >
        <div className="" >
          <div className="" >
            <div className="flex flex-col">
              <div>
                <div className="flex justify-between px-6 py-4 border-b-1 border-base">
                  <div data-testid="test-export-report-label" className="pr-6 pt-1 font-semibold">
                    <SaveAltIcon /> Export
                  </div>
                  <div>
                    <a data-testid="test-export-property-close" onClick={handleClose}> <ClearOutlinedIcon /> </a>
                  </div>
                </div>
              </div>
              <div className="pt-2 pb-4 px-6 popover-w disable-scrollbars flex">
                Show :
              </div>
              <div className="flex-column px-6 py-2 pb-4 popover-w">
                <div className="flex">
                  {template === "text" ?
                    <>
                      <span data-testid="test_showUnitMix" onClick={() => setUnitMix(!unitMix)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${unitMix ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        UnitMix
                      </span>
                      {/* <span data-testid="test_showMap" onClick={() => setMap(!map)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${map ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                          Map
                        </span> */}
                    </> :
                    <>
                      <span data-testid="test_showPhotos" onClick={() => isPhoto(!photo)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${photo ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        Photos
                      </span>
                      <span data-testid="test_showMap" onClick={() => setShowMap(!showMap)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${showMap ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        Map
                      </span>
                    </>

                  }

                  {propertyList && propertyList.compType === "Rent" &&
                    <>
                      <span data-testid="test_showOwner" onClick={() => setShowOwner(!showOwner)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${showOwner ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        Owner
                      </span>
                      <span data-testid="test_showManager" onClick={() => setShowManager(!showManager)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${showManager ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        Manager
                      </span>
                    </>
                  }

                  {propertyList && propertyList.compType === "Sales" &&
                    <>
                      <span data-testid="test_showBuyerSeller" onClick={() => setBuyerSeller(!buyerSeller)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${buyerSeller ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        BuyerSeller
                      </span>
                      <span data-testid="test_CAPRate" onClick={() => setCaprate(!caprate)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${caprate ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        CAPRate
                      </span>
                      <span data-testid="test_GRM" onClick={() => setGRM(!GRM)} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${GRM ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                        GRM
                      </span>
                    </>
                  }
                </div>
              </div>
            </div>
            <div className="flex flex-col px-6 py-4 border-t-1 border-base">
              <div className="pt-2 pb-4">Template : </div>
              <div className="flex flex-wrap gap-4">
                <span data-testid="test_template_text" onClick={() => setTemplate("text")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "text" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                  Non Formatted (Text only)
                </span>
                <span data-testid="test_template_default" onClick={() => setTemplate("default")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "default" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                  Formatted
                </span>
                {propertyList && propertyList.compType === "Sales" &&
                  <span data-testid="test_template_4up" onClick={() => setTemplate("4up")} className={`capitalize cursor-pointer badge rounded-pill px-5 mr-3 mb-1 py-3 ${template === "4up" ? 'text-primary bg-gray-10' : 'bg-white border-1 border-base'}`}>
                    4-Up Sales
                  </span>}
              </div>
              {/* <div id="output" className="absolute top-0 left-0" style={{ zIndex: '-1' }} >
                <img src={webURL} />
              </div> */}
              {/* <div id="output" className={`absolute top-0 left-0`} style={{ width: '720px', height: '320px', zIndex: '-1' }}>
                <MapComponent isScreenShot={true} fullHeight={true} propertyList={getMapsPropertyList()} showCluster={false} isList={true} />
              </div> */}
            </div>
            <div className="border-t-1 border-base mt-auto">
              <div className="flex justify-end px-6 py-4 space-x-4 mt-auto items-center">
                <div className="">
                  {exportClicked ?
                    <button style={{ 'bottom': '10px', 'right': '10px' }} className="btn btn-sm btn-primary c-disabled absolute">
                      <span className="loader h-5 w-5 mx-2" ></span>
                      <span className="px-2">Export</span>
                    </button>
                    :
                    <button style={{ 'bottom': '10px', 'right': '10px' }} data-testid="test-export-comps" className="btn btn-sm rounded px-5 absolute btn-primary"
                      onClick={() => setExportClicked(true)}>Export</button>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>

      </Popover>
    </>
  )
}

export default ExportListButton
